module.exports = __webpack_public_path__ + "static/media/N55.6ba05e8c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/N55.svg
// module id = 198
// module chunks = 0